import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Auth from "../../service/Auth";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import { Helmet } from "react-helmet"; // Import Helmet
import { CONFIG } from "../../helpers/constants";
import { useAuth } from "../../providers/AuthContext";
import { toast } from "react-toastify";

const ChangePassword = () => {
  const { logout } = useAuth();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const authApi = new Auth(CONFIG.BASE_URL);

  const [passwordState, setPasswordState] = useState({ newPassword: "", currentPassword: "", repeatPassword: "" });
  const changePasswordHandler = async () => {
    const { currentPassword, newPassword, repeatPassword } = passwordState;

    // Validation Logic
    if (!currentPassword) {
      setError("Current password is required.");
      return;
    }
    if (currentPassword && !newPassword && !repeatPassword) {
      setError("New password and repeat password required. ");
      return;
    }

    if (newPassword !== repeatPassword) {
      setError("New password and repeat password must match.");
      return;
    }

    if (currentPassword === newPassword) {
      setError("New password cannot be the same as the current password.");
      return;
    }

    // Clear errors if validation passes
    setError("");

    try {
      setIsLoading(true);
      const response = await authApi.userChangePassword({ newPassword, currentPassword });
      if (response.success) {
        logout();
        navigate("/");
        toast.success("Password updated successfully please login again and start new session");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
      } else {
        setError(response.message || "Failed to change password. Please try again.");
      }
    } catch (error) {
      console.error("Error during change password:", error);
      setError(error.response?.data.message || "An error occurred during change password. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto my-4 h-[calc(100vh-200px)] flex flex-col justify-center">
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
      </Helmet>
      <h2 className="font-light text-2xl text-center">Change Password</h2>
      <p className="text-slate-400 text-lg text-center mb-5">Please change your password to continue...</p>
      <form className="px-4 w-full">
        {/* Password Field */}
        <div className="block">
          <label className="block text-[#ababab] text-md font-medium mb-1">Current Password</label>
          <div className="relative">
            {/* Input Field */}
            <span className="absolute inset-y-0 left-0 pt-3 pl-4">
              <FaLock className="text-primary-dark" size={20} />
            </span>
            {/* Toggle Icon */}
            <input
              type={showPassword ? "text" : "password"}
              className="bg-no-repeat bg-left appearance-none rounded-lg p-3 pl-12 text-sm text-black w-full mb-4 border-0"
              required
              autoComplete="off"
              value={passwordState.currentPassword}
              onChange={(e) => {
                setPasswordState({ ...passwordState, currentPassword: e.target.value });
              }}
            />
            <span onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 pt-3 right-3">
              {showPassword ? <FaEye className="text-primary-dark" size={24} /> : <FaEyeSlash className="text-primary-dark" size={24} />}
            </span>
          </div>
        </div>

        <div className="block">
          <label className="block text-[#ababab] text-md font-medium mb-1">New Password</label>
          <div className="relative">
            {/* Input Field */}

            <span className="absolute inset-y-0 left-0 pt-3 pl-4">
              <FaLock className="text-primary-dark" size={20} />
            </span>
            {/* Toggle Icon */}
            <input
              type={showPassword ? "text" : "password"}
              className="bg-no-repeat bg-left appearance-none  rounded-lg p-3 pl-12 text-sm text-black w-full mb-4 border-0"
              required
              autoComplete="off"
              value={passwordState.newPassword}
              onChange={(e) => {
                setPasswordState({ ...passwordState, newPassword: e.target.value });
              }}
            />
            <span onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0  pt-3 right-3">
              {showPassword ? <FaEye className="text-primary-dark" size={24} /> : <FaEyeSlash className="text-primary-dark" size={24} />}
            </span>
          </div>
        </div>
        <div className="block">
          <label className="block text-[#ababab] text-md font-medium mb-1">Repeat New Password</label>
          <div className="relative">
            {/* Input Field */}

            <span className="absolute inset-y-0 left-0 pt-3 pl-4">
              <FaLock className="text-primary-dark" size={20} />
            </span>
            {/* Toggle Icon */}
            <input
              type={showPassword ? "text" : "password"}
              className="bg-no-repeat bg-left appearance-none  rounded-lg p-3 pl-12 text-sm text-black w-full mb-4 border-0"
              required
              autoComplete="off"
              value={passwordState.repeatPassword}
              onChange={(e) =>
                setPasswordState({
                  ...passwordState,
                  repeatPassword: e.target.value,
                })
              }
            />
            <span onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0  pt-3 right-3">
              {showPassword ? <FaEye className="text-primary-dark" size={24} /> : <FaEyeSlash className="text-primary-dark" size={24} />}
            </span>
          </div>
        </div>

        {/* Error Message */}
        {error && <div className="text-red-500 text-sm mb-4">{error}</div>}

        {/* Submit Button */}
        <button
          onClick={changePasswordHandler}
          className="bg-primary w-full font-medium px-3 py-2 mb-5 rounded-lg uppercase leading-3 text-sm transition duration-300 bg-fillButton h-10 mt-3 text-primary-dark disabled:opacity-50 disbaled:hover:bg-fillButton hover:bg-primary/80"
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : "Change Password"}
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
